<div class="hpanel gs-widget-cardmargin-bottom-5"  *ngIf="viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <ul class="profile-list">
          <ng-container *ngFor="let item of communitydata | slice: 0:3; let i = index">
            <app-common-profile-info [type]="'COMMUNITY'" [userIdInput]="item.userId" [data]="item" [page]="'COMMUNITY'">

              <ng-container headline1> {{item.communityName}}</ng-container>
              <ng-container headline2>{{item.memberCnt}} Follower(s)</ng-container>
              <ng-container btn><button class="btn-primary btn btn-xs">
                  Follow
                </button></ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right" *ngIf="communitydata?.length > 3">
          <u><a (click)="modelopen(user)">...More</a></u>
        </p> -->

        <button class="gs-743-more-btn" type="button"
                *ngIf="communitydata?.length > 0"
                (click)="modelopen(user)">
          View more →
        </button>

      </div>
    </div>
  </div>
</div>


<div class="margin-bottom-5"  *ngIf="viewType=='MAX'">
  <div class="panel-body cardw">
    <div class="row">
      <div class="col-3">
        <div class="col-md-3 padding-left-0 padding-right-5" *ngFor="let item of communitydata">
          <app-community-card [data]="item"></app-community-card>        </div>
      </div>
    </div>
  </div>
</div>


